export default function modals(state = {}, action) {
  if (action.type === 'SHOW_MODAL') {
    console.log("InShow Modal shared reducer")
    const { name, config = {} } = action;
    const nextState = { ...state };
    if (!nextState[name]) {
      nextState[name] = {
        name,
        state: config.state
      };
      return nextState;
    }
  } else if (action.type === 'HIDE_MODAL') {
    const { name } = action;
    const nextState = { ...state };
    if (nextState[name]) {
      delete nextState[name];
      return nextState;
    }
  } else if (action.type === 'UPDATE_MODAL') {
    const { name, config = {} } = action;
    const nextState = { ...state };
    nextState[name] = {
      name,
      state: config.state
    };
    return nextState;
  }
  return state;
}
